import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { InvoiceType } from '../../enums';
import { InvoiceTypePipe } from '../../pipes';

@Component({
  selector: 'app-invoice-type',
  imports: [CommonModule, InvoiceTypePipe],
  templateUrl: './invoice-type.component.html',
  styleUrl: './invoice-type.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InvoiceTypeComponent {
  public readonly type = input.required<InvoiceType>();

  protected readonly cssClass = computed(() => {
    switch (this.type()) {
      case InvoiceType.Temporary:
        return 'text-orange-500';

      case InvoiceType.Purchase:
        return 'text-lime-600';

      case InvoiceType.Correction:
        return 'text-sky-700';

      default:
        return '';
    }
  });
}
